import React, {Component} from 'react';
import Footer from 'common/Footer';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import notificationTheme from 'theme/notificationTheme';
import {updateAppData, dispatchAction} from 'actions';
import GuestLayoutHeader from 'guests/GuestLayoutHeader';
import classNames from 'classnames';
var NotificationSystem = require('react-notification-system');

class AppLayout extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    componentDidMount() {
         if (!this.props.appData.notification) {
            this.props.updateAppData({'notification': this.notificationSystem});
        }
         if (!_.includes(window.location.pathname, '/client/')) {
             if (this.props.userReducer.token) {
                if ((window.location.pathname == '/' || window.location.pathname == '' || window.location.pathname == '/login') && _.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom', 'Ops Manager', 'Product Manager','Financial Analyst',  'Administrator']))) {
                    this.context.router.push('/admin');
                }
            } else {
                 this.context.router.push('/login');
            }
        }
    }
    componentWillReceiveProps(nextProps) {
         if (this.props.appData.notification && !nextProps.appData.notification) { /* after log out */
             this.props.updateAppData({'notification': this.notificationSystem});
        }
    }
    render() {
        var location = window.location.pathname;
          var pageClasses = [];
        //if (location.match(/^\/client\//)) {
            if (_.includes(location,'/client/')){
            pageClasses.push('client-page')
         }
         return (
            <div className="reactPageContainer">
                <div className={  classNames('site-content', pageClasses.join(' '))}>
                    {(location.indexOf('/client/') == 0) ?
                        <GuestLayoutHeader {...this.props } ></GuestLayoutHeader> : null }
                    <div className="bgOffset"></div>

                    <NotificationSystem style={notificationTheme} ref={(el) => {
                        this.notificationSystem = el;
                    }}/>

                    {/*<RouteTransition*/}
                    {/*pathname={this.props.location.pathname}*/}
                    {/*atEnter={{translateX: 100}}*/}
                    {/*atLeave={{translateX: 0} }*/}
                    {/*atActive={{translateX: 0} }*/}
                    {/*mapStyles={styles => ({transform: `translateX(${styles.translateX}%)`})}*/}
                    {/*>*/}
                    <div className="  container">{this.props.children}</div>

                    {/*</RouteTransition>*/}
                </div>
                {(location.indexOf('/client/') == 0) ? null : <Footer {...this.props } ></Footer> }
            </div>

        );
    }

}
function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        appData: state.appData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({updateAppData, dispatchAction}, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);